import React from 'react';
import {
  USER_TYPE_ADMIN,
  USER_TYPE_MERCHANT,
  USER_TYPE_OPERATOR,
} from '../../../../constants';


import {
  account$,
  accountType$,
} from '../../../../emitters/account';
import withState from '../../../../utils/withState';
import DashboardForMerchantNew from './DashboardForMerchantNew';
import DashboardForKlubcoin from './DashboardForKlubcoin';


const DASHBOARD_MAP = {
  klubcoin_alike: DashboardForKlubcoin,
  [USER_TYPE_MERCHANT]: DashboardForMerchantNew,
  [USER_TYPE_OPERATOR]: DashboardForMerchantNew,
  [USER_TYPE_ADMIN]: DashboardForMerchantNew,
  // [USER_TYPE_ADMIN]: () => {
  //   replaceLocation({
  //     path: LINK_ADMIN_STATUS,
  //   });
  //   return null;
  // },
};


module.exports = withState(() => {
  return (state) => {
    const account = state.account || {};
    const type = account.is_klubcoin || account.is_ncdt
      ? 'klubcoin_alike'
      : state.accountType;

    const Component = DASHBOARD_MAP[type];
    return Component ? (<Component/>) : null;
  };
}, {
  account: account$,
  accountType: accountType$,
});
